<template>
	<div v-if="product.type === 'saas'" class="product-single-hover- border rounded h-100 bg-white"
		:class="itemLayout == 'horizontal' ? 'row' : ''">
		<div class="inline_product clickable d-flex justify-content-center"
			:class="itemLayout == 'horizontal' ? 'w-25' : ''" style="cursor: pointer;background:#3b71de10;"
			:style="imageStyle">
			<!-- <div class="d-flex justify-content-end for-dicount-div-null">
				<span class="for-discoutn-value-null"></span>
			</div> -->
			<div class="d-flex d-block" style="cursor: pointer;">
				<a :href="`/apps/${product.id}`">
					<el-image :src="imgProxy(product.image_url, rs = 'fill:300:300:1')"
						:alt="dt(product?.name_translations)" style="width: 100%; max-width: 300px" :style="imageStyle"
						>
						<template #error>
							<img src="/static/assets/front-end/img/image-place-holder.png"
								:alt="dt(product?.name_translations)" style="width: 100%;">
						</template>
					</el-image>
				</a>
			</div>
		</div>
		<div class="single-product-details position-relative p-2" :class="itemLayout == 'horizontal' ? 'w-75' : ''"
			:style="contentStyle">
			<div class="text-left text-truncate-2">
				<a :href="`/apps/${product.id}`">
					{{ dt(product.name_translations) }}
				</a>
			</div>
		</div>
		<div class="single-product-details position-relative p-2" :class="itemLayout == 'horizontal' ? 'w-75' : ''"
			:style="descriptionStyleStyle">
			<div class="text-left text-truncate-3">
				<a :href="`/apps/${product.id}`">
					{{ dt(product.seo_description_translations) }}
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, priceRange, imgProxy } from "../../utils"

const props = defineProps({
	product: Object,
	itemLayout: { type: String, default: "vertical" },
})

const { t, n, locale } = useI18n()

const displayCoinReward = computed(() => props.product?.display_coin_reward && props.product?.price_range?.min_owner_coin_reward > 0)
const contentStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '0px 5px 5px 0px',
		}
	}
	return {
		// minHeight: displayCoinReward.value ? '180px' : '150px',
		paddingTop: '10px !important',
		paddingBottom: '5px !important',
		fontWeight: '600',
		fontSize: '115%',
		borderRadius: '0px 0px 5px 5px',
	}
})
const descriptionStyleStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '0px 5px 5px 0px',
		}
	}
	return {
		// minHeight: displayCoinReward.value ? '180px' : '150px',
		paddingTop: '0px !important',
		borderRadius: '0px 0px 5px 5px',
	}
})
const imageStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '5px 0px 0px 5px',
		}
	}
	return {
		borderRadius: '5px 5px 0px 0px',
	}
})
</script>